import { Popover, Transition } from "@headlessui/react";
import { GetCurrentWindowSize } from "../../hooks/useWindowSize";
import CenteredModal from "./CenteredModal";
import SessionCardInfoContainer from "./views/SessionCardInfoContainer";
import { classNames } from "../../helpers";
import CalendarScheduleSlotModel from "../../models/CalendarScheduleSlotModel";
import { Fragment } from "react";

type SessionCardProps = {
  session: CalendarScheduleSlotModel;
  userType: "student" | "tutor";
  open: boolean;
  setOpen: (newState: boolean) => void;
  className: string;
  setIsOpen?: () => void;
  cancel: boolean;
};

export default function SessionCardModal({
  session,
  userType,
  open,
  setOpen,
  className,
  setIsOpen,
  cancel,
}: SessionCardProps) {
  const currentScreen = GetCurrentWindowSize();
  return (
    <>
      {currentScreen !== "sm" && currentScreen !== "md" ? (
        <Transition
          as={Fragment}
          show={open && !!session}
          enter="transition duration-100 ease-out"
          enterFrom="transform scale-95 opacity-0"
          enterTo="transform scale-100 opacity-100"
          leave="transition duration-75 ease-out"
          leaveFrom="transform scale-100 opacity-100"
          leaveTo="transform scale-95 opacity-0"
        >
          <Popover.Panel
            className={classNames(
              "hidden md:block   absolute z-[1]  transform -translate-y-full mt-2 w-screen  max-w-xs   xl:max-w-md rounded-md shadow-xl bg-white",
              !!className
                ? className
                : "rtl:left-[100%] ltr:right-[100%] top-[0.5rem]"
            )}
          >
            <div className="relative flex z-50 ">
              <SessionCardInfoContainer
                setIsOpen={setIsOpen}
                session={session}
                cancel={cancel}
              />
            </div>
          </Popover.Panel>
        </Transition>
      ) : (
        <CenteredModal open={open} setOpen={setOpen}>
          <SessionCardInfoContainer
            cancel={cancel}
            setIsOpen={setIsOpen}
            session={session}
          />
        </CenteredModal>
      )}
    </>
  );
}
